import React from "react";
import { useLocation } from "react-router-dom";

const getPaymentDetails = (search) => {
  const searchParams = new URLSearchParams(search);

  return {
    mode: searchParams.get("mode"),
    status: searchParams.get("status"),
    txnid: searchParams.get("txnid"),
    amount: searchParams.get("amount"),
    bank_ref_num: searchParams.get("bank_ref_num"),
    field9: searchParams.get("field9"),
  };
};

const formatAmount = (amount) => {
  if (!amount) {
    return "N/A";
  }

  const parsedAmount = Number.parseFloat(amount);
  return Number.isNaN(parsedAmount) ? amount : `${parsedAmount.toFixed(2)} INR`;
};

const MobilePaymentSuccess = () => {
  const location = useLocation();
  const paymentDetails = getPaymentDetails(location.search);

  return (
    <div className="payment-success-page-container">
      <div className="payment-success-card">
        <div className="payment-success-icon">OK</div>
        <h1 className="payment-success-heading">Payment Successful</h1>
        <p className="payment-success-text">
          Your payment has been processed successfully. You can return to the app.
        </p>

        <div className="payment-order-details">
          <h3>Payment Details</h3>
          <div className="payment-detail-item">
            <span>Transaction ID:</span>
            <span>{paymentDetails.txnid || "N/A"}</span>
          </div>
          <div className="payment-detail-item">
            <span>Amount:</span>
            <span>{formatAmount(paymentDetails.amount)}</span>
          </div>
          <div className="payment-detail-item">
            <span>Payment Mode:</span>
            <span>{paymentDetails.mode || "N/A"}</span>
          </div>
          <div className="payment-detail-item">
            <span>Bank Reference No:</span>
            <span>{paymentDetails.bank_ref_num || "N/A"}</span>
          </div>
          <div className="payment-detail-item">
            <span>Status:</span>
            <span>{paymentDetails.field9 || paymentDetails.status || "Success"}</span>
          </div>
        </div>

        <p className="payment-confirmation-text">Please close this page if the app does not return automatically.</p>
      </div>
    </div>
  );
};

export default MobilePaymentSuccess;
